export default __webpack_public_path__ + "static/media/icon-arrow-right.41ed51df.svg";